import { render, staticRenderFns } from "./ContestInfo.vue?vue&type=template&id=b17bd0f4&"
import script from "./ContestInfo.vue?vue&type=script&lang=js&"
export * from "./ContestInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports